export default "__VITE_PUBLIC_ASSET__34ef9e61__"